// import React from 'react';
// import video from '../img/robotics hands workingVideo.mp4';
// import { useNavigate } from 'react-router-dom';
// const MainBanner = () => {


//   return (



//     <div
//       className="hero-area overly-style-1 opacity-point-4"
//       style={{
//         height: '1100px',
//         width: '100%',
//         zIndex:'1',
//         position: 'relative', // Ensure relative positioning for z-index to work
//         overflow: 'hidden',
//       }}
//     >
//       {/* Background Video */}
//       <video
//         className="banner-video"
//         src={video}
//         autoPlay
//         loop
//         muted
//         playsInline
//         style={{
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '70%',
//           objectFit: 'cover', // Ensures the video covers the area
//           zIndex: -1, // Keeps the video behind content
//         }}
//       ></video>

//       {/* Overlay Content */}
//       <div
//         className="hero-content-1 hero-content-position"
//         style={{
//           position: 'relative', // Ensure content is positioned relative to parent
//           color: '#fff',
//           zIndex: 1, // Keeps content above the video
//           textAlign: 'center',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center', // Center content vertically
//           alignItems: 'center', // Center content horizontally
//           height: '100%', // Take full height of the banner
//         }}
//       >
//         <h1
//           style={{
//             color: '#fff',
//             fontFamily: 'Urbanist, serif',
//             fontWeight: 700,
//             letterSpacing: '9px',
//             marginTop:'-393px'
//           }}
//           className='mainbanner-content'
//         >
//          "Welcome to IIA–Where Innovation Meets Opportunity"

//         </h1>
//        <h3 style={{
//             color: '#fff',
//             // width:'50%',
//             textAlign:'center',
//             // marginTop:'50px',
//             fontSize:'20px',
//             fontWeight:'400 !important'
//           }} className='banner-second-data'>Believe in unlocking the power of innovation and to create new opportunities for growth and ultimate success.
//        </h3>
       
//       </div>
//     </div>
 
//   );
// };

// export default MainBanner;



// // import React from 'react';
// // import video from '../img/robotics hands workingVideo.mp4';

// // const MainBanner = () => {
// //   return (
// //     <div
// //       className="hero-area overly-style-1 opacity-point-4"
// //       style={{
// //         height: '950px',
// //         width: '100%',
// //         zIndex: '1',
// //         position: 'relative', // Ensure relative positioning for z-index to work
// //         overflow: 'hidden',
// //       }}
// //     >
// //       {/* Background Video */}
// //       <video
// //         className="banner-video"
// //         src={video}
// //         autoPlay
// //         loop
// //         muted
// //         playsInline
// //         style={{
// //           position: 'absolute',
// //           top: 0,
// //           left: 0,
// //           width: '100%',
// //           height: '100%',
// //           objectFit: 'cover', // Ensures the video covers the area
// //           zIndex: -1, // Keeps the video behind content
// //         }}
// //       ></video>

// //       {/* Overlay Content - Right Side */}
// //       <div
// //         className="hero-content-1 hero-content-position"
// //         style={{
// //           position: 'absolute', // Absolute position for top-right corner alignment
// //           top: '250px', // Adjust this value as needed
// //           right: '20px', // Right-side content
// //           color: '#fff',
// //           zIndex: 1, // Keeps content above the video
// //           textAlign: 'right', // Aligns text to the right
// //           display: 'flex',
// //           flexDirection: 'column',
// //           justifyContent: 'flex-start', // Adjust vertical alignment
// //           alignItems: 'flex-end', // Aligns content to the right
// //         }}
// //       >
// //         <h1
// //           style={{
// //             color: '#fff',
// //             fontFamily: 'Urbanist, serif',
// //             fontWeight: 700,
// //             letterSpacing: '9px',
// //             width: '50%',
// //             textAlign: 'center',
// //           }}
// //         >
// //           "Welcome to IIA–Where Innovation Meets Opportunity"
// //         </h1>
// //         <h3
// //           style={{
// //             color: '#fff',
// //             width: '50%',
// //             textAlign: 'center',
// //             fontSize: '16px',
// //             fontWeight: '400',
// //           }}
// //         >
// //           Believe in unlocking the power of innovation, and to create new
// //           opportunities for growth and ultimate success.
// //         </h3>
// //       </div>

// //       {/* Overlay Content - Left Side */}
// //       {/* <div
// //         className="hero-content-2 hero-content-position"
// //         style={{
// //           position: 'absolute', // Absolute position for top-left corner alignment
// //           top: '450px', // Adjust this value as needed
// //           left: '20px', // Left-side content
// //           color: '#fff',
// //           zIndex: 1, // Keeps content above the video
// //           textAlign: 'left', // Aligns text to the left
// //           display: 'flex',
// //           flexDirection: 'column',
// //           justifyContent: 'flex-start', // Adjust vertical alignment
// //           alignItems: 'flex-start', // Aligns content to the left
// //         }}
// //        >
// //         <h1
// //           style={{
// //             color: '#fff',
// //             fontFamily: 'Urbanist, serif',
// //             fontWeight: 700,
// //             letterSpacing: '9px',
// //             width: '50%',
// //             textAlign: 'center',
// //           }}
// //         >
// //           "Welcome to IIA–Where Innovation Meets Opportunity"
// //         </h1>
// //         <h3
// //           style={{
// //             color: '#fff',
// //             width: '50%',
// //             textAlign: 'center',
// //             fontSize: '16px',
// //             fontWeight: '400',
// //           }}
// //         >
// //           Believe in unlocking the power of innovation, and to create new
// //           opportunities for growth and ultimate success.
// //         </h3>
// //       </div> */}
// //       <div
// //   className="hero-content-2 hero-content-position"
// //   style={{
// //     position: 'absolute', // Absolute position for top-left corner alignment
// //     top: '450px', // Adjust this value as needed
// //     left: '20px', // Left-side content
// //     color: '#fff',
// //     zIndex: 1, // Keeps content above the video
// //     textAlign: 'left', // Aligns text to the left
// //     display: 'flex',
// //     flexDirection: 'column',
// //     justifyContent: 'flex-start', // Adjust vertical alignment
// //     alignItems: 'flex-start', // Aligns content to the left
// //   }}
// // >
// //   <ul
// //     style={{
// //       listStyleType: 'disc', // Adds bullet points for the list
// //       paddingLeft: '20px', // Indentation for the list items
// //     }}
// //   >
// //     <li
// //       style={{
// //         color: '#fff',
// //         fontFamily: 'Urbanist, serif',
// //         fontWeight: 700,
// //         letterSpacing: '9px',
// //         fontSize: '18px', // Adjusts font size for list item
// //         marginBottom: '10px', // Adds spacing between list items
// //       }}
// //     >
// //       "Welcome to IIA–Where Innovation Meets Opportunity"
// //     </li>
// //     <li
// //       style={{
// //         color: '#fff',
// //         fontSize: '16px', // Adjusts font size for the description
// //         fontWeight: '400',
// //         marginBottom: '10px', // Adds spacing between list items
// //       }}
// //     >
// //       Believe in unlocking the power of innovation, and to create new
// //       opportunities for growth and ultimate success.
// //     </li>
// //   </ul>
// // </div>

// //     </div>
// //   );
// // };

// // export default MainBanner;






// import React, { useEffect, useState } from 'react';
// import bannerImage from '../img/aaaservices/scann-3d.jpg'; // Update to your image path
// // import Engnneringautomation from './Engnneringautomation';
// // import Mechinical from './Mechinical';
// // import Proviedautomation from'./Proviedautomation';

// const Banner = () => {
//     const [animate, setAnimate] = useState(false);
//     const [showForm, setShowForm] = useState(false);

//     const handleOpenForm = () => setShowForm(true);
//     const handleCloseForm = () => setShowForm(false);

//     useEffect(() => {
//         setAnimate(true);
//     }, []);

//     return (
//         <>
//             <style>{`
//         .banner-container {
//           position: relative;
//           width: 100%;
//           height: 112vh;
//           max-height: 762px;
//           overflow: hidden;
//         }

//         .banner-image {
//           width: 100%;
//           height: 112vh;
//           max-height:762px;
//           object-fit: cover;
//         }

//         .banner-overlay {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background-color: rgba(0, 0, 0, 0.5);
//           z-index: 1;
//         }

//         .banner-text {
//           position: absolute;
//           bottom: 30%;
//           left: 5%;
//           color: white;
//           z-index: 2;
//           opacity: 0;
//           transform: translateY(50px);
//           transition: all 1s ease-out;
//           max-width: 700px;
//         }

//         .banner-text.animate {
//           opacity: 1;
//           transform: translateY(0);
//         }

//         .banner-heading {
//           font-size: 2.5rem;
//           font-weight: 700;
//           margin: 0;
//         }

//         .banner-heading .blue {
//           color: white;
//           text-transform: uppercase;
//         }

//         .banner-heading span:last-child {
//           color: gold;
//         }

//         .banner-subheading {
//           font-size: 1.125rem;
//           font-weight: 400;
//           margin-top: 15px;
//           line-height: 1.6;
//           text-align: left;
//           max-width: 600px;
//         }

//         .banner-text button {
//           margin-top: 20px;
//           background-color: #FACC15;
//           color: black;
//           padding: 12px 24px;
//           border-radius: 9999px;
//           border: none;
//           font-weight: 600;
//           cursor: pointer;
//         }

//         @media screen and (max-width: 768px) {
//           .banner-heading {
//             font-size: 2rem;
//           }

//           .banner-subheading {
//             font-size: 1rem;
//             max-width: 90%;
//           }
//         }

//         @media screen and (max-width: 480px) {
//           .banner-heading {
//             font-size: 1.5rem;
//           }

//           .banner-subheading {
//             font-size: 0.875rem;
//           }
//         }

//         .overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background-color: rgba(0, 0, 0, 0.6);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 1000;
//         }

//         .modal {
//           background-color: #fff;
//           padding: 30px;
//           border-radius: 12px;
//           width: 90%;
//           max-width: 400px;
//           box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
//           position: relative;
//         }

//         .modal h3 {
//           margin-bottom: 20px;
//           color: rgb(12 133 155);
//         }

//         .modal input {
//           width: 100%;
//           padding: 10px;
//           margin-bottom: 12px;
//           border-radius: 6px;
//           border: 1px solid #ccc;
//         }

//         .modal .submit-button {
//           background-color: #FACC15;
//           color: #fff;
//           padding: 10px;
//           border: none;
//           border-radius: 6px;
//           width: 100%;
//           font-weight: bold;
//           cursor: pointer;
//           margin-top: 10px;
//         }

//         .modal .close-button {
//           position: absolute;
//           top: 10px;
//           right: 10px;
//           background: transparent;
//           border: none;
//           font-size: 18px;
//           cursor: pointer;
//         }
//       `}</style>

//             <div className="banner-container">
//                 <img src={bannerImage} alt="Banner" className="banner-image" />
//                 <div className="banner-overlay"></div>
//                 <div className={`banner-text ${animate ? 'animate' : ''}`}>
//                     <h1 className="banner-heading">
//                         <span className="blue">Industrial Automation </span><span>Solutions</span>
//                     </h1>
//                     <p className="banner-subheading">
//                         we specialize in delivering state-of-the-art industrial automation solutions. Our mission is to enhance operational efficiency and productivity through innovative automation technologies.
//                     </p>
//                     {/* <button onClick={handleOpenForm}>Book Your Free Trial Class now →</button> */}
//                 </div>

//                 {showForm && (
//                     <div className="overlay">
//                         <div className="modal">
//                             <h3>Welcome to Envision Group</h3>
//                             <input type="text" placeholder="Name" />
//                             <input type="email" placeholder="Email" />
//                             <input type="tel" placeholder="Mobile" />
//                             <button className="submit-button">Submit</button>
//                             <button onClick={handleCloseForm} className="close-button">X</button>
//                         </div>
//                     </div>
//                 )}
//             </div>
//             {/* <Engnneringautomation />
//             <Proviedautomation/> */}
//            {/* <Mechinical/> */}
//         </>
//     );
// };

// export default Banner;





// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// // Image imports
// import img1 from '../Component/3d-img-1.jpg'; 
// import img2 from "../img/aaaservices/web-bg.jpg";
// import img3 from "../Component/DIG1.jpg";

// const slides = [
//   {
//     image: img1,
//     heading: "Welcome to the Future",
//     subtext: "Experience innovation like never before.",
//     buttonLabel: "Explore Now",
//   },
//   {
//     image: img2,
//     heading: "Design Beyond Limits",
//     subtext: "Unleashing creativity through technology.",
//     buttonLabel: "Start Designing",
//   },
//   {
//     image: img3,
//     heading: "Imagine. Create. Repeat.",
//     subtext: "Crafting digital dreams into reality.",
//     buttonLabel: "Get Inspired",
//   },
// ];

// export default function SliderComponent() {
//   const [index, setIndex] = useState(0);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setIndex((prev) => (prev + 1) % slides.length);
//     }, 5000);
//     return () => clearInterval(timer);
//   }, []);

//   const containerStyle = {
//     position: "relative",
//     width: "100%",
//     height: "100vh",
//     overflow: "hidden",
//   };

//   const backgroundStyle = (img) => ({
//     position: "absolute",
//     inset: 0,
//     backgroundImage: `url(${img})`,
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//     width: "100%",
//     height: "100%",
//   });

//   const overlayStyle = {
//     position: "absolute",
//     inset: 0,
//     backgroundColor: "rgba(0,0,0,0.4)",
//     zIndex: 10,
//   };

//   const textContainerStyle = {
//     position: "absolute",
//     inset: 0,
//     zIndex: 20,
//     display: "flex",
//     justifyContent: "flex-start",
//     alignItems: "center",
//     padding: "20px",
//   };

//   const textWrapperStyle = {
//     maxWidth: "90%",
//     color: "white",
//     textAlign: "left",
//   };

//   const headingStyle = {
//     fontSize: "54px",
//     fontWeight: "bold",
//     lineHeight: "1.2",
//     textAlign:'left'
//   };

//   const subTextStyle = {
//     fontSize: "20px",
//     fontWeight: "500",
//     marginTop: "10px",
//     color: "#f1f1f1",
//     textAlign:'left'
//   };

//   const buttonStyle = {
//     marginTop: "15px",
//     padding: "10px 20px",
//     fontSize: "16px",
//     backgroundColor: "#FFD700",
//     border: "none",
//     color: "black",
//     fontWeight: "600",
//     cursor: "pointer",
//     borderRadius: "4px",
//   };
  
  
  
//   const getColoredText = (text) => {
//     const words = text.split(" ");
//     const half = Math.ceil(words.length / 2);
//     return (
//       <>
//         <span style={{ color: "#FFD700" }}>
//           {words.slice(0, half).join(" ")}{" "}
//         </span>
//         <span style={{ color: "white" }}>
//           {words.slice(half).join(" ")}
//         </span>
//       </>
//     );
//   };

//   return (
//     <div style={containerStyle}>
//       <AnimatePresence>
//         <motion.div
//           key={slides[index].image}
//           style={backgroundStyle(slides[index].image)}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 1 }}
//         />
//       </AnimatePresence>

//       <div style={overlayStyle}></div>

//       <div style={textContainerStyle}>
//         <motion.div
//           key={slides[index].heading}
//           initial={{ x: 100, opacity: 0 }}
//           animate={{ x: 0, opacity: 1 }}
//           exit={{ x: -100, opacity: 0 }}
//           transition={{ duration: 0.8 }}
//           style={textWrapperStyle}
//         >
//           <div style={headingStyle}>{getColoredText(slides[index].heading)}</div>
//           <div style={subTextStyle}>{slides[index].subtext}</div>
//           <button style={buttonStyle}>
//             {slides[index].buttonLabel}
//           </button>
//         </motion.div>
//       </div>
//     </div>
//   );
// }





// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// // Image imports
// import img1 from "../Component/3d-img-1.jpg";
// import img2 from "../img/aaaservices/web-bg.jpg";
// import img3 from "../Component/DIG1.jpg";

// const slides = [
//   {
//     image: img1,
//     heading: "Welcome to the Future",
//     subtext: "Experience innovation like never before.",
//     buttonLabel: "Explore Now",
//   },
//   {
//     image: img2,
//     heading: "Design Beyond Limits",
//     subtext: "Unleashing creativity through technology.",
//     buttonLabel: "Start Designing",
//   },
//   {
//     image: img3,
//     heading: "Imagine. Create. Repeat.",
//     subtext: "Crafting digital dreams into reality.",
//     buttonLabel: "Get Inspired",
//   },
// ];

// export default function SliderComponent() {
//   const [index, setIndex] = useState(0);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setIndex((prev) => (prev + 1) % slides.length);
//     }, 5000);
//     return () => clearInterval(timer);
//   }, []);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const containerStyle = {
//     position: "relative",
//     width: "100%",
//     height: "100vh",
//     overflow: "hidden",
//   };

//   const backgroundStyle = (img) => ({
//     position: "absolute",
//     inset: 0,
//     backgroundImage: `url(${img})`,
//     backgroundSize: "cover",
//     backgroundPosition: isMobile ? "center top" : "center",
//     width: "100%",
//     height: "100%",
//   });

//   const overlayStyle = {
//     position: "absolute",
//     inset: 0,
//     backgroundColor: "rgba(0,0,0,0.4)",
//     zIndex: 10,
//   };

//   const textContainerStyle = {
//     position: "absolute",
//     inset: 0,
//     zIndex: 20,
//     display: "flex",
//     justifyContent: isMobile ? "center" : "flex-start",
//     alignItems: "center",
//     padding: isMobile ? "10px" : "20px",
//     textAlign: "left",
//   };

//   const textWrapperStyle = {
//     maxWidth: isMobile ? "100%" : "90%",
//     color: "white",
//   };

//   const headingStyle = {
//     fontSize: isMobile ? "28px" : "54px",
//     fontWeight: "bold",
//     lineHeight: "1.3",
//     marginBottom: "10px",
//   };

//   const subTextStyle = {
//     fontSize: isMobile ? "16px" : "20px",
//     fontWeight: "500",
//     color: "#f1f1f1",
//   };

//   const buttonStyle = {
//     marginTop: "15px",
//     padding: isMobile ? "8px 16px" : "10px 20px",
//     fontSize: isMobile ? "14px" : "16px",
//     backgroundColor: "#FFD700",
//     border: "none",
//     color: "black",
//     fontWeight: "600",
//     cursor: "pointer",
//     borderRadius: "4px",
//   };

//   const getColoredText = (text) => {
//     const words = text.split(" ");
//     const half = Math.ceil(words.length / 2);
//     return (
//       <>
//         <span style={{ color: "#FFD700" }}>
//           {words.slice(0, half).join(" ")}{" "}
//         </span>
//         <span style={{ color: "white" }}>
//           {words.slice(half).join(" ")}
//         </span>
//       </>
//     );
//   };

//   return (
//     <div style={containerStyle}>
//       <AnimatePresence>
//         <motion.div
//           key={slides[index].image}
//           style={backgroundStyle(slides[index].image)}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 1 }}
//         />
//       </AnimatePresence>

//       <div style={overlayStyle}></div>

//       <div style={textContainerStyle}>
//         <motion.div
//           key={slides[index].heading}
//           initial={{ x: 100, opacity: 0 }}
//           animate={{ x: 0, opacity: 1 }}
//           exit={{ x: -100, opacity: 0 }}
//           transition={{ duration: 0.8 }}
//           style={textWrapperStyle}
//         >
//           <div style={headingStyle}>
//             {getColoredText(slides[index].heading)}
//           </div>
//           <div style={subTextStyle}>{slides[index].subtext}</div>
//           <button style={buttonStyle}>
//             {slides[index].buttonLabel}
//           </button>
//         </motion.div>
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Image imports
import img1 from "../Component/3d-img-1.jpg";
import img2 from "../img/aaaservices/web-bg.jpg";
import img3 from "../Component/DIG1.jpg";

const slides = [
  
  {
  image: img1,
  heading: "Build Your IT Career",
  subtext:
    "Building a strong IT career requires the right skills, practical exposure, and industry-focused training. This program is designed to help you master in-demand technologies that are widely used in today’s IT industry. ",
     buttonLabel: "Join Now",
},
{
  image: img2,
  heading: "Full Stack Development",
  subtext:
    "Full Stack Development is a highly demanded skill that enables you to build complete web applications from start to finish. This program covers frontend, backend, and database technologies to help you become a well-rounded developer. ",
     buttonLabel: "Join Now",
},
{
  image: img3,
  heading: "Job Ready Programs",
  subtext:
    "Our Job Ready Programs are designed to prepare you for real-world IT jobs with practical, industry-aligned training. You will gain hands-on experience through live projects, assignments, and real-time problem-solving exercises. ",
     buttonLabel: "Join Now",
}

];

export default function SliderComponent() {
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "100vh",
    overflow: "hidden",
  };

  const backgroundStyle = (img) => ({
    position: "absolute",
    inset: 0,
    backgroundImage: `url(${img})`,
    backgroundSize: "cover",
    backgroundPosition: isMobile ? "center top" : "center",
    width: "100%",
    height: "100%",
  });

  const overlayStyle = {
    position: "absolute",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.45)",
    zIndex: 10,
  };

  const textContainerStyle = {
    position: "absolute",
    inset: 0,
    zIndex: 20,
    display: "flex",
    justifyContent: isMobile ? "center" : "flex-start",
    alignItems: "center",
    padding: isMobile ? "20px" : "80px",
    textAlign: "left",
  };

  const textWrapperStyle = {
    maxWidth: isMobile ? "100%" : "900px",
    color: "white",
  };

  const headingStyle = {
    fontSize: isMobile ? "30px" : "35px",
    fontWeight: "700",
    lineHeight: "1.3",
    marginBottom: "15px",
  };

  const subTextStyle = {
    fontSize: isMobile ? "16px" : "20px",
    fontWeight: "400",
    textWrapperStyle: "1.6",
    color: "#f1f1f1",
    lineHeight: "1.6",
  };

  const buttonStyle = {
    marginTop: "20px",
    padding: isMobile ? "10px 18px" : "12px 26px",
    fontSize: isMobile ? "14px" : "16px",
    backgroundColor: "#FFD700",
    border: "none",
    color: "black",
    fontWeight: "600",
    cursor: "pointer",
    borderRadius: "6px",
  };

  const getColoredText = (text) => {
    const words = text.split(" ");
    const half = Math.ceil(words.length / 2);
    return (
      <>
        <span style={{ color: "#FFD700" }}>
          {words.slice(0, half).join(" ")}{" "}
        </span>
        <span style={{ color: "white" }}>
          {words.slice(half).join(" ")}
        </span>
      </>
    );
  };

  const handleJoinClick = () => {
    window.location.href = "/contact";
  };

  return (
    <div style={containerStyle}>
      <AnimatePresence>
        <motion.div
          key={slides[index].image}
          style={backgroundStyle(slides[index].image)}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
        />
      </AnimatePresence>

      <div style={overlayStyle}></div>

      <div style={textContainerStyle}>
        <motion.div
          key={slides[index].heading}
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: -100, opacity: 0 }}
          transition={{ duration: 0.8 }}
          style={textWrapperStyle}
        >
          <div style={headingStyle}>
            {getColoredText(slides[index].heading)}
          </div>
          <div style={subTextStyle}>{slides[index].subtext}</div>
          <button style={buttonStyle} onClick={handleJoinClick}>
            {slides[index].buttonLabel}
          </button>
        </motion.div>
      </div>
    </div>
  );
}
